export { default as API_END_POINTS }  from './apiEndPoints';

export default {
    BASE_URL: '',
    IS_USER_LOGGED_IN: 'isLoggedIn',
    STATIC_MEDIA_BASE_URL: '',
    CMS_BASE_URL: '',
    S3_BASE_URL: '',
    PB_VERSION: '',
    DEV_MODE: false
}

export const UPLOADING_ASSETS_ROUTE = '/uploadAssets';

export const SITEMAP = 'Sitemap';

export const ATTACHED = 'Attached' 

export const previewOptions = [
  {
    id: "Desktop",
    title: "Desktop",
  },
  {
    id: "Tablet (768px)",
    title: "Tablet (768px)",
  },
  {
    id: "Mobile (360px)",
    title: "Mobile (360px)",
  },
];

export const livePreview = [
  {
    id: "Live Preview",
    title: "Live Preview",
    disabled: true,
  },
  {
    id: "Live Desktop",
    title: "Desktop",
  },
  {
    id: "Live Tablet (768px)",
    title: "Tablet (768px)",
  },
  {
    id: "Live Mobile (360px)",
    title: "Mobile (360px)",
  },
];

export const localLivePreview = [
  {
    id: "Local Preview",
    title: "Local Preview",
    disabled: true,
  },
  ...previewOptions,
  {
    id: "Live Preview",
    title: "Live Preview",
    disabled: true,
  },
  {
    id: "Live Desktop",
    title: "Desktop",
  },
  {
    id: "Live Tablet (768px)",
    title: "Tablet (768px)",
  },
  {
    id: "Live Mobile (360px)",
    title: "Mobile (360px)",
  },
];


export const PB_REPLACE_CONSTANTS = {
  // eslint-disable-next-line no-template-curly-in-string
  IMAGE_BASE_URL: '${STATIC_BASE_URL}',
  // eslint-disable-next-line no-template-curly-in-string
  LOGGED_IN_USER_NAME_PLACEHOLDER: '${fullName}'
};


export const appData = {
  IMAGE_BASE_URL: process.env.REACT_APP_IMAGE_BASE_URL || '',
  AWS_PATH: process.env.REACT_APP_S3_BASE_URL || `https://s3.eu-central-1.amazonaws.com/eshop-dev-ec1-sales-catalog-sylius/`
}